import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
	Grid,
	Box,
	Card,
	CardContent,
	List,
	ListItem,
	ListItemText,
	Typography,
} from '@material-ui/core';

// icons
import { getGlobalClasses } from '../../themes';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			overflow: 'hidden',
			backgroundColor: '#e5e5e6',
		},
		panel: {
			marginTop: 30,
		},
		emptyPanel: {
			minHeight: 270,
			fontWeight: 100,
			color: '#aaa',
			fontSize: 30,
			marginTop: 30,
		},
		innerPaper: {
			padding: 10,
			paddingTop: 5,
			textAlign: 'left',
			fontSize: 14,
			[theme.breakpoints.up('md')]: {
				padding: 40,
				paddingTop: 30,
			},
		},
		lastFtpCheck: {
			//marginTop : 20,
			//color : "#888"
		},
		ftpSection: {
			lineHeight: 1.6,
			marginTop: 10,
		},
		title: {
			textTransform: 'uppercase',
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
			marginBottom: 5,
		},
		label: {},

		labelDate: {
			fontSize: 12,
			fontWeight: 100,
			color: '#999',
		},
		value: {
			fontWeight: 600,
		},
		statusIcon: {
			position: 'absolute',
			right: 0,
		},
		ftpWarning: {
			color: '#FFC107',
		},
		ftpGood: {
			color: '#4CAF50',
		},
		ftpStatusIcon: {
			width: 14,
			height: 14,
			verticalAlign: 'middle',
			paddingLeft: 5,
		},
		ftpStatusIconLarge: {
			width: 32,
			height: 32,
			verticalAlign: 'middle',
		},
		dataSection: {
			marginTop: 25,
			lineHeight: 1.6,
		},
		dgsButton: {
			position: 'relative',
			right: 0,
			borderRadius: 100,
		},
		dgsButtonContainer: {
			display: 'flex',
			justifyContent: 'flex-end',
			marginTop: 30,
		},
		tableRow: {
			fontWeight: 400,
		},
		row: {
			margin: 0,
			width: '100%',
			backgroundColor: '#fff',
		},
		oddRow: {
			margin: 0,
			width: '100%',
			backgroundColor: '#eee',
		},
		masthead: {
			textAlign: 'left',
			fontSize: 24,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 15,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,

			[theme.breakpoints.up('sm')]: {
				fontWeight: 300,
				fontSize: 22,
				//margin: '10px 0px 10px 0px',
			},
			[theme.breakpoints.up('md')]: {
				fontSize: 30,
				//margin: '10px 0px 10px 0px',
			},
		},
		subMasthead: {
			textAlign: 'left',
			fontSize: 18,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 10,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,
		},
	};
};

const billToEmails = {
	ANTHEM: [
		'anthemoilinc@gmail.com',
		'cravaliya@gmail.com',
		'dinesh.ram37@gmail.com',
		'kmsolanki318@gmail.com',
		'sandipm.goriya@gmail.com',
	],
	BOYETTCO: ['BOL@boyett.net', 'TCastillo@boyett.net'],
	BOYETTLA: ['BOL@boyett.net', 'TCastillo@boyett.net'],
	BOYETTSD: ['BOL@boyett.net', 'TCastillo@boyett.net'],
	BOYETTPX: ['BOL@boyett.net', 'TCastillo@boyett.net'],
	B4LENGY: ['Jessuceh@galaxyb4l.com'],
	EFUELSW: ['AP@efuelco.com', 'nozly@efuelco.com'],
	EDSTBPHX: ['bol@edstaub.com'],
	RTC: ['ap@pearsonfuels.com'],
	SCFSW: ['images-carrier@scfuels.com'],
	SMP: ['smpenergyy@gmail.com', 'amirsmp@yahoo.com'],
	CGALIANC: ['customerservice@afuelservice.com'],
	'W-FPDX': ['transportbilling@wilcoxandflegel.com', 'krobinson@wilcoxandflegel.com'],
	'W-FTCSEA': ['transportbilling@wilcoxandflegel.com', 'krobinson@wilcoxandflegel.com'],
};

class CustomerMapping extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		const { classes } = this.props;

		return (
			<>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.globalMainHeadline}>Customer Mapping</div>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Box sx={{ display: 'grid', gap: 2, padding: 3, maxWidth: 600, margin: 'auto' }}>
							{Object.entries(billToEmails).map(([customer, emails]) => (
								<Card key={customer} sx={{ boxShadow: 3, borderRadius: 2 }}>
									<CardContent>
										<div variant="h6" sx={{ fontWeight: 'bold' }}>
											{customer}
										</div>
										<List dense>
											{emails.map((email, index) => (
												<ListItem key={index} sx={{ paddingY: 0 }}>
													<ListItemText primary={email} />
												</ListItem>
											))}
										</List>
									</CardContent>
								</Card>
							))}
						</Box>
					</Grid>
				</Grid>
			</>
		);
	}
}

CustomerMapping.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles)])(CustomerMapping);
